<template>
  <div class="subsystemTreeMenu">
    <div style="width: 100%; height: 80%; margin: 10px 0 20px 0">
      <el-input placeholder="请输入关键字" v-model="filterText"></el-input>
      <el-tree :data="treeData" :props="defaultProps" accordion :default-expanded-keys="defaultKeys"
               :filter-node-method="filterNode"
               node-key="id"
               highlight-current
               ref="tree"
               empty-text=""
               style="overflow: auto;background: #f7f7f7;border: 1px solid #e7e7e7;border-radius: 6px;padding: 20px 0 30px;margin-top: 10px;height: 80%;"></el-tree>
    </div>
    <div class="buttons">
      <el-button type="primary" style="width: 100%" @click="onSubmit">确 认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyTreeMenu",
  data() {
    return {
      treeData: [],
      defaultData: {}, //默认选中的第一个数据
      defaultKeys: [], //默认打开
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    /**
     * 如果父组件改变了 assets 属性的值，则需要重新渲染子组件
     * */
    assets(newVal, oldVal) {
      if (newVal !== oldVal) {
          this.getAssetList();
      }
    }
  },
  methods: {
    onSubmit() {
      if (!this.$refs.tree.getCurrentKey()) {
        this.$message.error("请选择资产");
        return;
      }
      this.$emit("getActiveItem", this.$refs.tree.getCurrentNode());
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getAssetList() {
      if (this.hasAssets) {
        let _this = this;
        this.treeData = [this.assets.区域位置];
        this.defaultData = this.treeData[0];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(_this.defaultData.id);
          this.defaultKeys.push(_this.defaultData.id);
          this.$emit("getActiveItem", this.$refs.tree.getCurrentNode());
        });
      }
    },
  },
  created() {
    this.getAssetList();
  },
  props: {
    assets: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  computed: {
    /**
     * 判断父组件是否为 assets 赋值
     * */
    hasAssets() {
      return JSON.stringify(this.assets) !== '{}';
    },
  }
}
</script>

<style lang="scss" scoped>
.subsystemTreeMenu {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;

  ::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }

  .buttons {
    width: 55%;
    margin: 20px auto;
  }
}
</style>
